import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
// @mui

// ----------------------------------------------------------------------

export default function MainLayout() {
  return (
    <Box minHeight={'100%'}>
      <Container maxWidth='sm' sx={{ paddingX: 0, backgroundColor: 'none' }}>
        <Outlet />
      </Container>
    </Box>
  );
}
